<template>
  <div
    :class="{'modal-large' :params.referents && params.referents.length}"
    class="modal-card">
    <div class="row-width-actions-bar">
      <div class="columns is-gapless is-vcentered is-border-bottom is-marginless">
        <div class="column is-padding-left">
          <div class="has-text-dark is-size-6 is-uppercase">
            <span class="has-text-weight-medium">Nouveau ticket de support</span>
          </div>
        </div>
        <div class="column is-narrow is-border-left">
          <a
            class="page-header-btn is-small is-square"
            @click="close">
            <span class="icon is-size-4 has-text-dark"><i class="fal fa-times"></i></span>
          </a>
        </div>
      </div>
      <div class="columns is-gapless has-background-warning is-marginless">
        <div class="is-size-7 is-padding-left is-padding-right is-padding-top-xsmall">
          <span class="is-uppercase has-text-weight-bold">FONCTIONNEMENT : LE PROMOTEUR SERA DIRECTEMENT INFORMÉ DE VOTRE DEMANDE. VOUS SEREZ  AUTOMATIQUEMENT NOTIFIÉ DE LA PRISE EN CHARGE
            AINSI QUE DE LA RÉPONSE DU RESPONSABLE</span>
        </div>
      </div>
    </div>
    <div class="columns is-marginless has-background-white is-padding-top-xsmall">
      <!-- REFERENT PRESCRIBER -->
      <div
        v-if="params.referents && params.referents.length"
        class="column is-5 has-background-white is-paddingless-top">
        <div class="has-text-black has-text-weight-normal is-size-5 has-text-centered  is-underline is-margin-bottom-xsmall">
          Référent(s)
        </div>
        <div
          v-for="(referent,i) in params.referents"
          :key="i"
          class="columns">
          <div
            class="column is-self-centered is-radius-large has-text-centered is-4">
            <span class="vadPicto is-xlarge">
              <img
                class="veryFastAnimation"
                v-if="referent.picture"
                :src="referent.picture.cloudinary_id | avatarHeader">
              <avatar
                class="is-xlarge"
                v-else-if="!referent.picture && referent.last_name && referent.first_name"
                :item="{last_name:referent.last_name, first_name: referent.first_name}"
                :i="i" />
              <img
                class="veryFastAnimation"
                v-else
                src="/img/placeholder/default-avatar.jpg"
                width="92"
                height="9240">
            </span>
          </div>
          <div class="column is-padding-right-small">
            <div class="">
              <b class="has-text-primary">{{ referent.profession || 'Interlocuteur' }} : <br></b>
              <span v-if="referent.last_name || referent.first_name">{{ referent.last_name }} {{ referent.first_name }}</span>
              <span v-else>NC</span>
            </div>
            <div class="is-padding-top-xxsmall">
              <b class="has-text-primary">Mail : </b>
              <a
                v-if="referent.email"
                :href="`mailto:${referent.email}`"
                class="is-hover-underline">{{ referent.email }}</a>
              <span v-else>NC</span>
            </div>
            <div class="">
              <b class="has-text-primary">Téléphone : </b><span>{{ referent.phone || 'NC' }}</span>
            </div>
          </div>
        </div>
      </div>
      <section
        :class="params.referents && params.referents.length ? 'is-7' : 'is-12'"
        class="column modal-card-body">
        <form
          id="form-create-ticket"
          class="is-clipped">
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="field">
                <r-label
                  :label="'Sujet'"
                  :is-required="false"
                  :value="ticket.title"></r-label>
                <div class="select is-fullwidth is-paddingless-left">
                  <select
                    id="ticket_subject"
                    v-model="ticket.subject"
                    class="has-text-weight-medium">
                    <option value="program_information">
                      Information programme
                    </option>
                    <option value="lot_information">
                      Information lot
                    </option>
                    <option value="access">
                      Mandat
                    </option>
                    <option value="contact">
                      Contact
                    </option>
                    <option value="reservation">
                      Gestion réservation/vente
                    </option>
                    <option value="other">
                      Autre sujet
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="column is-12">
              <r-label
                :label="'Objet de votre message (minimum 5 caractéres)'"
                :is-required="true"
                :value="ticket.title"></r-label>
              <v-input
                id="title"
                name="title"
                @input="val => ticket.title = val"
                :model="ticket.title"
                data-vv-as="titre"
                v-validate="'required|min:5|max:100'"
                :errors-bag="errors"
                data-vv-value-path="val">
              </v-input>
            </div>
            <div class="column is-12">
              <r-label
                :is-required="true"
                :label="'Votre Message'"
                :value="ticket.message"></r-label>
              <textarea
                id="message"
                name="message"
                v-model="ticket.message"
                @input="errorMessage = false"
                label="Message"
                data-vv-value-path="val"
                data-vv-as="message"
                class="textarea"
                rows="7">
              </textarea>
              <p
                v-if="errorMessage"
                class="help is-danger">
                Le champ message doit contenir au minimum 10 caractères
              </p>
            </div>
            <div class="colum is-12">
              <upload-file
                :custom-id="'program'"
                :multiple="true"
                @upload="uploadDocument({ files: $event, target: 'documents' })"
                @deleteDocument="deleteDocument({ document: $event, target: 'documents' })"
                :source-documents="ticket.documents"></upload-file>
            </div>
          </div>
        </form>
      </section>
    </div>
    <div class="formActionsSticky is-bottom">
      <div class=" columns is-gapless is-centered has-background-white is-padding-top-small is-padding-bottom-small">
        <div class="column is-4 is-3-widescreen is-margin-right-small">
          <a
            @click="close()"
            class="button is-light is-uppercase is-fullwidth">
            <span>Annuler</span>
          </a>
        </div>
        <div class="column is-4 is-3-widescreen is-margin-left-small">
          <button
            @click="submit"
            class="button is-success is-uppercase is-fullwidth has-text-white"
            :class="{'is-loading': buttonLoading}"
            type="submit">
            <span>Envoyer message</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Document } from '@/mixins'
export default {
  name: 'CreateTicket',
  mixins: [Document],
  props: {
    active: {
      type: Boolean,
      required: true
    },
    params: {
      type: Object
    }
  },
  data () {
    return {
      ticket: {
        title: null,
        subject: null,
        message: null,
        documents: [],
        promoteur: null
      },
      errorMessage: false,
      buttonLoading: false
    }
  },
  computed: {
    documentEl () {
      return this.ticket
    },
    patchElement () {
      return undefined
    }
  },
  created () {
    if (this.params.defaultTitle) {
      this.ticket.title = this.params.defaultTitle
    }
    if (this.params.defaultSubject) {
      this.ticket.subject = this.params.defaultSubject
    }
    this.ticket.promoteur = this.params.promoteur
  },
  methods: {
    close () {
      this.$emit('close')
    },
    async submit () {
      this.buttonLoading = true
      const formIsValid = await this.$validator.validateAll()
      if (formIsValid) {
        try {
          const { data } = await this.$api.post(this.$resources.TICKET, this.ticket)
          this.$toasted.global.success('Ticket créé')
          this.close()
          this.$router.push({ name: 'TicketVue', params: { id: data.pk } })
        } catch (err) {
          console.log(err)
          this.$toasted.global.danger('Erreur lors de la création du ticket')
        } finally {
          this.buttonLoading = false
        }
      } else if (this.ticket.message === null || this.ticket.message.length < 10) {
        this.errorMessage = true
        this.buttonLoading = false
      }
    }
  }
}
</script>

<style lang="sass">
.modal-large
  width: 880px
</style>
